module.exports = __webpack_public_path__ + "img/haha.c3c61a75.png";